import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

function Header() {
  return {
    handleToggle({ detail }, isOpen) {
      const { id } = detail;
      if (id === 'mainNav') {
        if (isOpen) {
          disableBodyScroll(this.$el);
          this.$refs.lensWrapper.classList.add('opacity-0', 'collapse');
        } else {
          enableBodyScroll(this.$el);
          this.$refs.lensWrapper.classList.remove('opacity-0', 'collapse');
        }
      }
    },
  };
}

export default Header;
